import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ToastNotification = ({ show, message, onClose, bg = 'success' }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose(); 
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null; 

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1050,
        minWidth: '300px',
      }}
    >
      <div className={`toast show text-white bg-${bg} border-0`} role="alert">
        <div className="d-flex">
          <div className="toast-body">{message}</div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            aria-label="Close"
            onClick={onClose} 
          />
        </div>
      </div>
    </div>
  );
};



export default ToastNotification;
